export enum WeekDays {
    "SETTINGS.ALVOLO.HOURS.WEEK_DAY_SHORT.MONDAY" = 1,
    "SETTINGS.ALVOLO.HOURS.WEEK_DAY_SHORT.TUESDAY" = 2,
    "SETTINGS.ALVOLO.HOURS.WEEK_DAY_SHORT.WEDNESDAY" = 3,
    "SETTINGS.ALVOLO.HOURS.WEEK_DAY_SHORT.THURSDAY" = 4,
    "SETTINGS.ALVOLO.HOURS.WEEK_DAY_SHORT.FRIDAY" = 5,
    "SETTINGS.ALVOLO.HOURS.WEEK_DAY_SHORT.SATURDAY" = 6,
    "SETTINGS.ALVOLO.HOURS.WEEK_DAY_SHORT.SUNDAY" = 0
}